import { useCurrencyCode } from "../hooks/useCurrencySymbol";
import { useFeature } from "./useFeature";

// USDT deposits top up the balance instead of charging a payment provider, so
// they are a partner feature rather than a backend `payment_methods` entry.
// The backend credits USDT 1:1 into the account currency, hence the USD guard.
export const useUsdtDepositsEnabled = (): boolean => {
  const enabled = useFeature("usdtDeposits");
  const currencyCode = useCurrencyCode();

  return enabled && currencyCode === "USD";
};
